import environment from '../../../common/environment';
import { PRODUCT_SCHOOL_LEVEL_FILTER } from '../interfaces/search-filter.interface';
import { PerformIsbnSearchParams, PerformSearchParams, SearchFacet, SearchFacetValue } from '../interfaces/search.interface';
import { capitalizeText, mapCatalog } from '../../../common/utils/util';
import { facetSorter } from '../utils/facet.util';
import { getSearchBody, getSearchUrl } from '../utils/search.util';

/*----- HELPERS -----*/
export async function getSearchApiCall(params: PerformSearchParams) {
  const url = getSearchUrl(params.catalog, params.store, params.categoryId);
  const body = getSearchBody(params);

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })
    .then((res) => (res.status <= 399 ? res.json() : false))
    .then((json) => {
      if (json) {
        if(json.facets) {
          json.facets.forEach((facet: SearchFacet) => {
            if ([PRODUCT_SCHOOL_LEVEL_FILTER].indexOf(facet.name) === -1)
              facet.facetValues.sort((v1, v2) => facetSorter(facet.name, v1, v2));

            if (facet.label) facet.label = capitalizeText(facet.label);

            facet.facetValues.forEach((value: SearchFacetValue) => {
              if (
                params.fieldValueFilter &&
                params.fieldValueFilter[facet.name] &&
                params.fieldValueFilter[facet.name].includes(value.name)
              ) {
                value.selected = true;
              }

              if (value.children) {
                value.children.sort((v1, v2) => facetSorter(value.name, v1, v2));
                value.children.forEach((child: SearchFacetValue) => {
                  if (
                    params.fieldValueFilter &&
                    params.fieldValueFilter[facet.name] &&
                    params.fieldValueFilter[facet.name].includes(child.name)
                  ) {
                    child.selected = true;
                  }
                });
              }
            });
          });
        }
        return json;
      } else {
        return false;
      }
    });
}

export function getIsbnSearchApiCall(params: PerformIsbnSearchParams) {
  const url = `${environment().searchServiceUrl}/v2/products/metadata`;
  const body = {
    businessUnit: params.businessUnit,
    identifiers: params.identifiers,
    isInternational: params.isInternational,
  };
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })
    .then((res) => (res.status <= 399 ? res.json() : false))
    .then((json) => {
      return json ? json : false;
    });
}

export function getPopularSearchApiCall({
  businessUnit = "all",
}: {
  businessUnit?: string;
}) {
  const url = `${environment().searchServiceUrl}/v1/popularSearch`;
  const body = {
    "catalog": mapCatalog(businessUnit)
  };
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })
    .then((res) => (res.status <= 399 ? res.json() : false))
    .then((json) => {
      return json?.response?.results || [];
    });
}